export default __webpack_public_path__ + "static/media/Poppins-Light.f41b63c0.ttf";